import React from "react"
import Modal from "src/components/modals/Modal"
import {
  compose,
  withStateHandlers,
  withProps,
  withPropsOnChange,
  withHandlers,
} from "recompact"
import { P } from "@infotech/uikit-text"
import ModalConfirm from "src/components/modals/ModalConfirm"
import noop from "lodash/noop"
import NotFoundSideModal from "src/components/NotFoundSideModal"
import { goBack } from "src/hocs/withSideModalPending"
import getWordByModelName from "src/helpers/text/getWordByModelName"
import createModalConfObj from "./helpers/createModalConfObj"
import styles from "./styles.css"

const DEFAULT_MODAL_WIDTH = 440

export default compose(
  withProps(props => ({ defaultModalConf: createModalConfObj(props) })),
  withStateHandlers(
    ({ defaultModalConf }) => ({
      modalConf: defaultModalConf,
      isDefaultModalConf: true,
      isConfirmationModalOpen: false,
    }),
    {
      overrideModalConf: ({ modalConf }) => newModalConf => ({
        modalConf: {
          ...modalConf,
          ...newModalConf,
        },
        isDefaultModalConf: false, // So withPropsOnChange below won't affect buttons
      }),
      resetModalConf: (state, { defaultModalConf }) => () => ({
        modalConf: defaultModalConf,
        isDefaultModalConf: true,
      }),
      setModalConf: () => modalConf => ({
        modalConf,
        isDefaultModalConf: true,
      }),
      openConfirmationModal: () => () => ({
        isConfirmationModalOpen: true,
      }),
      closeConfirmationModal: () => () => ({
        isConfirmationModalOpen: false,
      }),
    },
  ),
  withHandlers({
    handleConfirmClick: ({
      modalConf: { cancelHandler },
      closeConfirmationModal,
    }) => e => {
      e.preventDefault()
      cancelHandler()
      closeConfirmationModal()
    },
  }),
  withPropsOnChange(
    (props, nextProps) =>
      nextProps.isDefaultModalConf &&
      (props.dirty !== nextProps.dirty ||
        props.pending !== nextProps.pending ||
        props.invalid !== nextProps.invalid ||
        props.id !== nextProps.id ||
        props.isDefaultModalConf !== nextProps.isDefaultModalConf),
    ({ setModalConf, ...restProps }) => {
      setModalConf(createModalConfObj(restProps))
    },
  ),
)(
  ({
    pending,
    isOpen,
    children,
    width = DEFAULT_MODAL_WIDTH,
    fullWidth,
    fullHeight,
    modalConf: { buttonConf, title: modalConfTitle, cancelHandler },
    overrideModalConf,
    resetModalConf,
    title,
    dirty,
    isConfirmationModalOpen,
    openConfirmationModal,
    closeConfirmationModal,
    isDefaultModalConf,
    handleConfirmClick,
    disableSubmit = false,
    isValidId,
    noFooter,
    history,
    modelName,
  }) => {
    let content = null
    // If isValidId === undefined, than we don't have withRouteValidation
    // wrapper above, so there's no need to show 404 modal about incorrect id
    if (isValidId === false) {
      content = (
        <NotFoundSideModal
          isValidId={false}
          handleUpdate={() => goBack(history)}
          message={`${getWordByModelName(modelName, false, true)} не найден`}
        />
      )
    } else if (typeof children === `function`) {
      content = children({
        overrideModalConf,
        resetModalConf,
      })
    } else if (children) {
      content = children
    }
    return (
      <Modal
        title={title || modalConfTitle}
        buttonConf={
          disableSubmit ? buttonConf.filter(one => !one.isOk) : buttonConf
        }
        isOpen={isOpen}
        onCancel={
          isDefaultModalConf && dirty && !disableSubmit
            ? openConfirmationModal
            : cancelHandler
        }
        pending={pending}
        fullWidth={fullWidth}
        fullHeight={fullHeight}
        width={width}
        noFooter={noFooter || isValidId === false}
      >
        {content}
        <ModalConfirm
          isOpen={isConfirmationModalOpen}
          title="Закрыть без сохранения?"
          buttonConf={[
            {
              text: `Закрыть`,
              onClick: dirty ? handleConfirmClick : noop,
              isOk: true,
              done: true,
              disabled: false,
            },
            {
              text: `Отмена`,
              onClick: closeConfirmationModal,
              disabled: false,
            },
          ]}
          isClose
        >
          <div className={styles[`modal-message-wrapper`]}>
            <P className={styles[`modal-message-text`]}>
              Все сделанные вами изменения будут утеряны
            </P>
          </div>
        </ModalConfirm>
      </Modal>
    )
  },
)
